import {useRef, useState} from "react";
import {Button} from "@mui/material";
import {CommentEditor} from "./CommentEditor";
import Quill from "quill";
import {api} from "../../api/API";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../misc/SyncedRef";
import {grey} from "@mui/material/colors";

export function Compose(props: {
    task2: number;
    onUpdate(): void;
}) {
    const [compose, setCompose] = useState(false);

    return (
        <div style={{minWidth: 400}}>
            {!compose ? <button style={{
                    padding: 8,
                    borderRadius: 4,
                    border: "1px solid #ccc",
                    backgroundColor: "white",
                    color: grey["500"],
                    width: "100%",
                    textAlign: "left",
                    cursor: "pointer",
                }} onClick={() => {
                    setCompose(true);
                }}>Write a comment</button> :
                <ComposeInner defaultValue={""}
                              onSubmit={async (value) => {
                                  await api.tasks2.updateComment({
                                      id: 0,
                                      task2: props.task2,
                                      body: value,
                                      meta: {},
                                      archived: false,
                                  } as any);

                                  setCompose(false);
                                  props.onUpdate()
                              }}
                              onCancel={() => {
                                  setCompose(false);
                              }} />
            }
        </div>
    )
}

export function ComposeInner(props: {
    defaultValue?: string;
    onSubmit(value: string): Promise<any>
    onCancel(): void;
}) {
    const quillRef = useRef<Quill>();
    const onSubmitRef = useSyncedRef(props.onSubmit);
    const action = useAsyncAction(input => onSubmitRef.current(input), [])

    return (
        <div>
            <div style={{
                backgroundColor: "white",
                position: "relative",
                zIndex: 3,
            }} onKeyDown={e => {
                if(e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
                    e.preventDefault();
                    if(!quillRef.current) return;

                    const html = fixQuillMultiRootNode(quillRef.current.getSemanticHTML());
                    action.callback(html);
                }
            }}>
                <CommentEditor
                    ref={quillRef}
                    defaultValue={props.defaultValue}
                />
            </div>

            <div style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                marginTop: 4,
            }}>
                <Button variant="contained" onClick={() => {
                    if(!quillRef.current) return;

                    const html = fixQuillMultiRootNode(quillRef.current.getSemanticHTML());
                    action.callback(html);
                }}>Save</Button>
                <Button onClick={() => props.onCancel()}>Cancel</Button>
                {action.LoadingElement}
            </div>
        </div>
    )
}

// fix issues where there's no single root node
export function fixQuillMultiRootNode(html: string) {
    return `<div>` + html + `</div>`
}